import api from './index';

export const driversApi = {
  getAll: async (params = {}) => {
    const response = await api.get('/drivers', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/drivers/${id}`);
    return response.data;
  },

  create: async (data) => {
    // FormData handling is done by the axios interceptor
    const response = await api.post('/drivers', data);
    return response.data;
  },

  update: async (id, data) => {
    // FormData handling is done by the axios interceptor
    const response = await api.put(`/drivers/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/drivers/${id}`);
    return response.data;
  },

  getTrips: async (driverId, params = {}) => {
    const response = await api.get(`/drivers/${driverId}/trips`, { params });
    return response.data;
  },
};

